<template>
  <section class="vision-section" id="vision">
    <div class="container">
      <div class="section-header">
        <h2 class="section-title">{{ $t('vision.title') }}</h2>
        <p class="section-subtitle">{{ $t('vision.subtitle') }}</p>
      </div>
      
      <div class="vision-description-block">
        <p class="vision-description">
          {{ $t('vision.description') }}
        </p>
      </div>
      
      <!-- 四维能力矩阵卡片 -->
      <div class="capability-matrix">
        <div class="capability-card">
          <div class="card-left-accent"></div>
          <div class="card-header">
            <div class="card-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"/>
              </svg>
            </div>
            <h3 class="card-title">{{ $t('vision.education') }}</h3>
          </div>
          <p class="card-description">{{ $t('vision.educationDesc') }}</p>
          <div class="card-badge">
            <span class="badge-label">{{ $t('vision.educationBadge') }}</span>
            <span class="badge-text">{{ $t('vision.educationBadgeText') }}</span>
          </div>
        </div>
        
        <div class="capability-card">
          <div class="card-left-accent"></div>
          <div class="card-header">
            <div class="card-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M3 7v10a2 2 0 0 0 2 2h2v3h2v-3h8v3h2v-3h2a2 2 0 0 0 2-2V7"/>
                <path d="M3 7V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2"/>
              </svg>
            </div>
            <h3 class="card-title">{{ $t('vision.enterprise') }}</h3>
          </div>
          <p class="card-description">{{ $t('vision.enterpriseDesc') }}</p>
          <div class="card-badge">
            <span class="badge-label">{{ $t('vision.enterpriseBadge') }}</span>
            <span class="badge-text">{{ $t('vision.enterpriseBadgeText') }}</span>
          </div>
        </div>
        
        <div class="capability-card">
          <div class="card-left-accent"></div>
          <div class="card-header">
            <div class="card-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/>
                <path d="M12 6v6l4 2"/>
              </svg>
            </div>
            <h3 class="card-title">{{ $t('vision.technology') }}</h3>
          </div>
          <p class="card-description">{{ $t('vision.technologyDesc') }}</p>
          <div class="card-badge">
            <span class="badge-label">{{ $t('vision.technologyBadge') }}</span>
            <span class="badge-text">{{ $t('vision.technologyBadgeText') }}</span>
          </div>
        </div>
        
        <div class="capability-card">
          <div class="card-left-accent"></div>
          <div class="card-header">
            <div class="card-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
              </svg>
            </div>
            <h3 class="card-title">{{ $t('vision.society') }}</h3>
          </div>
          <p class="card-description">{{ $t('vision.societyDesc') }}</p>
          <div class="card-badge">
            <span class="badge-label">{{ $t('vision.societyBadge') }}</span>
            <span class="badge-text">{{ $t('vision.societyBadgeText') }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'VisionSection'
}
</script>

<style scoped>
.vision-section {
  padding: 6rem 0;
  background: linear-gradient(135deg, #050B16 0%, #0B1630 60%, #0E1C3A 100%);
  position: relative;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.section-header {
  text-align: center;
  margin-bottom: 2rem;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 800;
  color: #F9FAFB;
  margin-bottom: 0.8rem;
  letter-spacing: -0.5px;
}

.section-subtitle {
  font-size: 1.1rem;
  color: #9CA3AF;
  font-weight: 500;
}

.vision-description-block {
  max-width: 800px;
  margin: 0 auto 4rem;
  text-align: center;
}

.vision-description {
  font-size: 1rem;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.75);
}

/* 四维能力矩阵 */
.capability-matrix {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
}

/* 卡片样式 */
.capability-card {
  position: relative;
  background: linear-gradient(135deg, #0B1220 0%, #0F172A 100%);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  padding: 2rem;
  transition: all 0.3s ease;
  overflow: hidden;
}

.capability-card::before {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 0% 0%, rgba(0, 180, 255, 0.1) 0%, transparent 60%);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.capability-card:hover {
  border-color: rgba(255, 255, 255, 0.15);
  transform: translateY(-4px);
}

.capability-card:hover::before {
  opacity: 1;
}

.card-left-accent {
  position: absolute;
  left: 0;
  top: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(180deg, #00D9FF 0%, #0066FF 50%, transparent 100%);
  border-radius: 16px 0 0 16px;
}

.card-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.card-icon {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 217, 255, 0.15);
  border: 1px solid rgba(0, 217, 255, 0.3);
  border-radius: 12px;
  color: #00D9FF;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.capability-card:hover .card-icon {
  background: rgba(0, 217, 255, 0.25);
  border-color: rgba(0, 217, 255, 0.6);
  color: #00E5FF;
}

.card-icon svg {
  width: 24px;
  height: 24px;
  stroke-width: 2;
}

.card-title {
  font-size: 1.3rem;
  font-weight: 700;
  color: #F9FAFB;
  margin: 0;
}

.card-description {
  font-size: 0.95rem;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.65);
  margin-bottom: 1.5rem;
  margin-top: 0.5rem;
}

/* 数据标签 */
.card-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 0.6rem 1rem;
  transition: all 0.3s ease;
}

.capability-card:hover .card-badge {
  background: rgba(0, 217, 255, 0.1);
  border-color: rgba(0, 217, 255, 0.3);
}

.badge-label {
  font-size: 0.9rem;
  font-weight: 700;
  color: #00D9FF;
}

.badge-text {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.6);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .vision-section {
    padding: 4rem 0;
  }

  .container {
    padding: 0 1.5rem;
  }

  .section-title {
    font-size: 2rem;
  }

  .vision-description {
    font-size: 0.95rem;
  }

  .capability-matrix {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .capability-card {
    padding: 1.5rem;
  }
}

</style>
